import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'jhi-login-new',
  templateUrl: './login-new.component.html',
  styleUrls: ['./login-new.component.scss']
})
export class LoginNewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  show_button: boolean = false;
  show_eye: boolean = false;
 
 showPassword() {
    this.show_button = !this.show_button;
    this.show_eye = !this.show_eye;
  }
}
